<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col lg="4">
            <label>Township Group</label>
            <v-select
              v-model="township_group_id"
              outlined
              dense
              item-text="name"
              item-value="id"
              :items="townshipGroups"
            ></v-select>
          </v-col>
          <v-col lg="4">
            <label>Start Date</label>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="start_date"
                  outlined
                  dense
                  readonly
                  persistent-hint
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="start_date"
                no-title
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col lg="4">
            <label>End Date</label>
            <v-menu
              ref="menu_end"
              v-model="menu_end"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="end_date"
                  outlined
                  dense
                  readonly
                  persistent-hint
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="end_date"
                no-title
                @input="menu_end = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="form-btn" @click="exportData">
          <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  components: {},
  data: () => ({
    township_group: null,
    start_date: null,
    end_date: null,
  }),
  computed: {
    ...mapState("TownshipGroup", ["townshipGroups"]),
  },
  methods: {
    exportData() {
      let data = {
        township_group_id: this.township_group_id,
      };
      if (this.start_date && this.end_date) {
        data.start_date = moment(this.start_date).format("YYYY-MM-DD");
        data.end_date = moment(this.end_date).format("YYYY-MM-DD");
      }
      this.$store.dispatch("Presumptive/getExport", data);
    },
  },
  created() {
    this.$store.dispatch("TownshipGroup/getTownshipGroups");
  },
};
</script>

<style scoped></style>
